import { combineReducers } from "redux";
import orderCorrectionReducer from "./orderCorrectionReducer";

const rootReducer = combineReducers({
  orderCorrectionController: orderCorrectionReducer
});

export default rootReducer;
